export default "<app-header></app-header>\r\n<router-outlet (activate)=\"onActivate()\"></router-outlet>\r\n<app-footer></app-footer>\r\n"